const DiscardMessage = ({ discardOn, message }) => {
  return (
    <p
      className={`md:mb-4 text-xs md:text-sm ${
        discardOn ? " text-red-700" : " text-amber-500"
      }`}
    >
      <strong> ⓘ Note : </strong> {message}
    </p>
  );
};

export default DiscardMessage;
